import React from 'react';

import { cn } from 'lib/helpers/utility';

import Dot from 'components/shared/Dot/Dot';
import {
  formatLabel,
  isEmptyOrBlank,
  renderValue
} from 'components/shared/ExpandableToolbar/lib/helpers';
import Typography from 'components/shared/Typography/Typography';

const ACTION_MAP = {
  create: 'created',
  update: 'updated',
  delete: 'deleted',
  upload: 'uploaded'
};

const NEW_LINE_KEYS = ['procedures'];

const ActivityContent = ({ creator, content = {}, action }) => {
  const { previousValues = {}, currentValues = {} } = content || {};
  const fullName = creator ? `${creator.f_name} ${creator.l_name}` : '';

  const previousKeys = Object.keys(previousValues);
  const currentKeys = Object.keys(currentValues);

  const isSingleKey = previousKeys.length === 1;
  const isDelete = action === 'delete';
  const isUpload = action === 'upload';
  const isAttachment = isDelete || isUpload;

  const authorInfoElement = (
    <Typography variant="p" size="xs" color="neutral-700" className="whitespace-nowrap">
      {fullName} {ACTION_MAP[action]}
      {isSingleKey ? '' : ':'}
    </Typography>
  );

  return (
    <ul className={`flex ${isSingleKey ? 'flex-row flex-wrap' : 'flex-col'} gap-1`}>
      {!isSingleKey && previousKeys.length > 0 && <li>{authorInfoElement}</li>}

      {previousKeys.length > 0
        ? previousKeys.map((key, index) => {
            const isNestedCreate = action === 'create' || isEmptyOrBlank(previousValues[key]);

            const prevValue = renderValue(key, previousValues[key]);
            const currValue = renderValue(key, currentValues[key]);

            if (prevValue === currValue) return null;

            return (
              <li key={key} className="flex flex-wrap gap-1 text-xs leading-5 text-neutral-700">
                {index === 0 && isSingleKey && authorInfoElement}
                <span className="font-medium">{formatLabel(key)}</span>

                {!isNestedCreate && (
                  <>
                    {!isAttachment && (
                      <>
                        <span className="text-neutral-700">from</span>
                        {NEW_LINE_KEYS.includes(key) && <div className="block w-full" />}
                      </>
                    )}
                    {(!isAttachment || isDelete) && (
                      <div className="flex items-center gap-1">
                        <Dot color="danger" size="sm" />
                        <span dangerouslySetInnerHTML={{ __html: prevValue }} />
                      </div>
                    )}

                    {!isAttachment && (
                      <span
                        className={cn(
                          'text-neutral-700',
                          NEW_LINE_KEYS.includes(key) && 'self-end'
                        )}>
                        to
                      </span>
                    )}
                  </>
                )}

                {(!isAttachment || isUpload) && (
                  <div className="flex items-center gap-1">
                    <Dot color="success" size="sm" />
                    <span
                      className="inline-flex font-medium text-neutral-800"
                      dangerouslySetInnerHTML={{ __html: currValue }}
                    />
                  </div>
                )}
              </li>
            );
          })
        : currentKeys.map((key) => (
            <li
              key={key}
              className="flex flex-wrap items-center gap-1 whitespace-nowrap text-xs leading-5 text-neutral-700">
              {authorInfoElement}

              <span className="font-medium">{formatLabel(key)}</span>
              <div className="flex items-center gap-1">
                <Dot color={isDelete ? 'danger' : 'success'} size="sm" />
                <span className="inline-flex whitespace-nowrap font-medium text-neutral-800">
                  {renderValue(key, currentValues[key]) || 'blank'}
                </span>
              </div>
            </li>
          ))}
    </ul>
  );
};

export default ActivityContent;
